var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { AbstractBrowserStorage } from './storage.abstract_browser';
/**
 * Storage object which saves information to the browser session storage.
 *
 * @export
 * \@class SessionStorage
 *
 * @author Scott O'Bryan
 * \@since 1.0
 */
export var SessionStorage = (function (_super) {
    __extends(SessionStorage, _super);
    function SessionStorage() {
        _super.call(this, sessionStorage);
    }
    return SessionStorage;
}(AbstractBrowserStorage));
//# sourceMappingURL=storage.session.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-persistence/src/services/storage/storage.session.js
// module id = 862
// module chunks = 3